module.exports = __webpack_public_path__ + "img/25_63.d30ab57b.png";